import { render } from "./timeslots.vue?vue&type=template&id=8c849bee&scoped=true"
import script from "./timeslots.vue?vue&type=script&lang=js"
export * from "./timeslots.vue?vue&type=script&lang=js"

import "./timeslots.vue?vue&type=style&index=0&id=8c849bee&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c849bee"]])

export default __exports__